module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/8bd98f3c4973bbc117baf4db16a97102.png";